var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3314 17.9965C12.3314 18.5487 12.7791 18.9965 13.3314 18.9965C13.8837 18.9965 14.3314 18.5487 14.3314 17.9965V13.665H17.9965C18.5487 13.665 18.9965 13.2173 18.9965 12.665C18.9965 12.1127 18.5487 11.665 17.9965 11.665H14.3314V8C14.3314 7.44771 13.8837 7 13.3314 7C12.7791 7 12.3314 7.44771 12.3314 8V11.665H8C7.44772 11.665 7 12.1127 7 12.665C7 13.2173 7.44772 13.665 8 13.665H12.3314V17.9965Z",
    fill: "#E5B910"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.04c3f35b0019c30d0418b31c737b0245.svg";
export { ForwardRef as ReactComponent };